import React from "react";
import CategoryFilteredVisits from "./CategoryFilteredVisits";

const DrugScreensList = (props) => {
  return (
    <CategoryFilteredVisits
      {...props}
      visitCategories={["Employer Services - Drug Screens"]}
      title="Employer Services - Drug Screens"
      screenType="drugscreen"
    />
  );
};

export default DrugScreensList;
